import React from "react"
import PropTypes from "prop-types"

const TileContainer = ({ children }) => (
  <>
    <div className="foundation-tile-container-top" />
    <div className="foundation-tile-container-body">{children}</div>
    <div className="foundation-tile-container-bottom" />
  </>
)

TileContainer.propTypes = {
  children: PropTypes.node.isRequired,
}
export default TileContainer
